import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import { ActionTypes as CommonActions } from '../models/actions/common';
import { ErrorActionTypes, errors, fallbackError } from '../errors/errors';
import IErrorState from '../models/IErrorState';
import ApplicationError from '@sunbit-dev/common/models/ApplicationError';

function getInitialState(): IErrorState & {
  submitActionType?: ErrorActionTypes;
  status: ActionStatus | null;
  show: boolean;
} {
  return {
    status: null,
    isModal: false,
    isPage: false,
    title: null,
    description: null,
    buttonTitle: null,
    show: false,
    code: null,
    cancelApplication: false,
  };
}

type ErrorReducerState = ReturnType<typeof getInitialState>;

export default function errorReducer(
  state: ErrorReducerState = getInitialState(),
  action: { status: ActionStatus; error: ApplicationError; type: any; payload: any }
): ErrorReducerState {
  if (typeof state === 'undefined') {
    return getInitialState();
  }

  if (action.type === CommonActions.ClearState) {
    return getInitialState();
  }

  if (CommonActions.ClearError === action.type) {
    return { ...state, show: false }; // do not reset the code, so the page behind can act on it
  }

  if (action.type === '@@router/LOCATION_CHANGE') {
    return state;
  }

  if (action.status !== ActionStatus.Failure) {
    return state;
  }
  const serverErrorCode = action && action.error && (action.error.code as string);
  const actionType = action.type as ErrorActionTypes;
  const baseError = { ...state, ...action, show: true };

  if (serverErrorCode) {
    const error = errors[actionType] ? (errors[actionType] as { [key: string]: any })[serverErrorCode] : null;
    if (error) {
      return { ...baseError, ...error, code: serverErrorCode };
    }
  }
  return { ...baseError, ...fallbackError, code: null };
}
